import React, { useEffect, useState } from 'react'
import {makeStyles} from '@material-ui/core'
import { CTAButton } from '../../components'
import { Space,Table, Badge, Popover, Button } from 'antd'
import {PlusOutlined, MoreOutlined} from '@ant-design/icons'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import { useData } from '../../../../data'
import NewUser from './new'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%'
    },
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    content: {
        padding: theme.spacing(3, 0)
    },
    divided: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    table: {
        maxWidth: '100%',
        width: '100%'
    }
}))


/**
 * Admin view page for user
 * 
 * List all signed up users to the platform for the admin and provide the option to create new users
 * By clicking on the 'NewUser' button, it opens up a drawer with form inputs for a new user
 */

const UsersAdminPage = (props) => {
    const [users, setUsers] = useState([])
    const [showNewUser, setShow] = useState(false)

    const classes = useStyles()
    const data = useData()
    const usersApi = data.users()

    const newUser = () => setShow(true)

    // load all users 
    const loadUsers = () => {
        trackPromise(
            usersApi.getAllUsers()
                .then(users => {
                    setUsers(users)
                }).catch(console.log)
        )
    }
    
    // get a list of all users 
    useEffect(() => {
        loadUsers()

        // eslint-disable-next-line
    }, [])

    // render user actions
    const actions = record => {
        const {id, is_active} = record 

        // activate a user 
        const activate = async () => {
            await usersApi.activateUser(id)

            loadUsers()
        }
        
        // deactivate a user 
        const deactivate = async () => {
            await usersApi.deActivateUser(id)

            loadUsers()
        }


        return (
            <Space direction="vertical">
                <Button type="link" size="small" onClick={is_active ? deactivate : activate}>{is_active ? 'Deactivate' : 'Activate' }</Button>
            </Space>
        )
    }

    // users table schema 
    const usersSchema = [
        {
            key: 'id',
            title: 'Id',
            dataIndex: 'id'
        },
        {
            key: 'email',
            title: 'Email',
            dataIndex: 'email'
        },
        {
            key: 'first_name',
            title: 'First name',
            dataIndex: 'first_name'
        },
        {
            key: 'last_name',
            title: 'Last name',
            dataIndex: 'last_name'
        },
        {
            key: 'admin',
            title: 'Is admin',
            dataIndex: 'is_superuser',
            render: (value, _) => <Badge status={value ? 'success' : 'error'} />
        },
        {
            key: 'active',
            title: 'Is active',
            dataIndex: 'is_active',
            render: (value, _) => <Badge status={value ? 'success' : 'error'} />
        },
        {
            key: 'actions',
            title: 'Actions',
            render: (_, record) => (
                <Popover placement="right" content={() => actions(record)} trigger="click"><MoreOutlined /></Popover>
            )
        }
    ]

    const {promiseInProgress} = usePromiseTracker()

    const closeDrawer = () => {
        setShow(false)
        loadUsers()
    }

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <h1>Users ({users.length})</h1>
                <CTAButton
                    onClick={newUser}
                >
                    <Space>
                        <PlusOutlined /> 
                        Add a User
                    </Space>
                </CTAButton>
            </div>

            <div className={classes.content}>
                <div className={classes.divided}>
                    <Table 
                        className={classes.table}
                        columns={usersSchema}
                        dataSource={users}
                        loading={promiseInProgress}
                    />


                </div>
                <NewUser 
                    close={closeDrawer}
                    visible={showNewUser}
                />

            </div>
            
        </div>
    )
}



export default UsersAdminPage